/**
 * Ajustes locales — singleton.
 *
 * NO se sincroniza. El tema es una preferencia del dispositivo: oscuro en el
 * teléfono y claro en la PC es un caso legítimo, no una desincronización.
 *
 * `profiles` no existe (cambio aprobado #5): `semanaActual` y
 * `baselineCompletado` se DERIVAN de las sesiones. Guardarlos garantizaría que
 * algún día se desincronicen de la realidad.
 *
 * `domain/` NO importa de `curriculum/`: la dependencia va en un solo sentido
 * (curriculum → domain/modelo) y el test de fronteras lo verifica. Por eso la
 * duración se declara aquí en vez de importar `Duracion`.
 */

export const CLAVE_AJUSTES = 'singleton';

export type Tema = 'claro' | 'oscuro' | 'sistema';

/** Las tres duraciones. Debe coincidir con `DURACIONES` del curriculum. */
export type DuracionSesion = 20 | 35 | 50;

export interface Ajustes {
  tema: Tema;
  /** Última duración elegida, para preseleccionarla. */
  duracionPreferida: DuracionSesion;
  /** El onboarding se muestra una sola vez (CA-3.15). */
  onboardingVisto: boolean;
  /** Resultado de `navigator.storage.persist()`, para poder informarlo. */
  almacenamientoPersistente?: boolean;
}

export const AJUSTES_POR_DEFECTO: Ajustes = {
  tema: 'sistema',
  duracionPreferida: 35,
  onboardingVisto: false,
};
